<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/898kBm/tc-custom/9781488090349.jpg?1721429486764" alt="This image is the cover for the book Bachelor's Baby, Liberty Creek"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bachelor's Baby, Liberty Creek
      </h1>
      <p class="bookDescription body article font2">
        <b>Forging a Family</b><br/><br/>Single mom-to-be Lindsay Holland is hoping for a fresh start in her sleepy New England hometown. First on her agenda is finding a way to support herself and her precious baby. But the only job opening is as an office manager for her high-school sweetheart—the man she once ran from. She knows Brian Calhoun needs help resurrecting his family’s blacksmith shop, but can she get him to take a chance on her? Organizing a Valentine’s Day fund-raiser together makes Lindsay realize just how much she wants a second chance with the handsome craftsman. As sparks fly, can they transform their rekindled friendship into a new, loving family?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mia Ross
      </h2>
      
      <p class="authorDescription body article">Mia Ross loves great stories. She enjoys reading about fascinating people, long-ago times, and exotic places. But only for a little while, because her reality is pretty sweet. A lifelong resident of Upstate New York, she's married and the proud mom of 2 amazing kids whose schedules keep her hopping. Busy as she is, she can't imagine trading her life for anyone else's--and she has a pretty good imagination. You can visit her online at www.miaross.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f8f03e7